//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';
import { useDispatch } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';

// === COMPONENTS ===
import { Login } from 'pages/Login';
import { PageManager } from 'pages/PageManager/PageManager';
import { PrivateRoute } from 'components';

// === STORE ===
import { actions as modeActions, constants as modeConstants } from 'store/modules/correctionMode';
import { actions as fieldsActions } from 'store/modules/fields';
import { actions as themeActions } from 'store/modules/theme';

// === HOOKS ===
import { ColorModeProvider } from './components/ColorModeContext/ColorModeContext';
import { AppProvider       } from './components/AppContext/AppContext';
import { SessionProvider   } from 'pages/PageManager/components/SessionContext';

import { socket } from '../../api/prokey/prokey.websocket';

//#endregion

socket.onInactive(() => {
  console.warn('Session inactive → forcing logout');

  // clear auth state
  localStorage.removeItem('token'); // or whatever you use
  sessionStorage.clear();

  // hard redirect (don’t rely on router state)
  window.location.href = '/prokeyweb/login';
});

socket.onReconnectFail(() => {
  console.warn('Reconnect failed → forcing logout');
  window.location.href = '/prokeyweb/login';
});

//-----------------------------------------------------------------
function App() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const dispatch = useDispatch();

  //#endregion

  //#region [PROCES]

  toggleTheme();
  toggleCorrectMode();

  //#endregion

  //#region [MODIFY]

  // function to set a given theme/color-scheme
  //-----------------------------------------------------------------
  function setTheme(themeName) {
    //-----------------------------------------------------------------
    localStorage.setItem('theme', themeName);
    document.documentElement.className = themeName;
  }

  // function to toggle between light and dark theme
  //-----------------------------------------------------------------
  function toggleTheme() {
    //-----------------------------------------------------------------
    const theme = localStorage.getItem('theme');
    if (theme) {
      setTheme(theme);
      dispatch(themeActions.setTheme(theme));
    } else {
      setTheme('theme-light');
      dispatch(themeActions.setTheme('theme-light'));
    }
  }

  //-----------------------------------------------------------------
  function setCorrectMode(mode) {
    //-----------------------------------------------------------------
    if (mode === modeConstants.ALL) {
      localStorage.setItem('correct-mode', modeConstants.ALL);
      dispatch(modeActions.correctAll());
      dispatch(fieldsActions.displayAll());
    }
    if (mode === modeConstants.EXCEPTIONS) {
      localStorage.setItem('correct-mode', modeConstants.EXCEPTIONS);
      dispatch(modeActions.correctExceptions());
      dispatch(fieldsActions.displayExceptions());
    }
    if (mode === modeConstants.HYBRID) {
      localStorage.setItem('correct-mode', modeConstants.HYBRID);
      dispatch(modeActions.correctUncertain());
      dispatch(fieldsActions.displayUncertain());
    }
  }

  //-----------------------------------------------------------------
  function toggleCorrectMode() {
    //-----------------------------------------------------------------
    const mode = localStorage.getItem('correct-mode');
    if (mode) setCorrectMode(mode);
    else setCorrectMode(modeConstants.EXCEPTIONS);
  }

  //#endregion

  return (
    <AppProvider>
      <ColorModeProvider>
        <Routes>
          <Route path='login/*' element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path='/*' element={<SessionProvider><PageManager /></SessionProvider>} />
          </Route>
          <Route path='*' element={<Navigate to='login' replace />} />
        </Routes>
      </ColorModeProvider>
    </AppProvider>
  );
}

export default App;
